module.exports = __webpack_public_path__ + "img/eae-slide-9.de814685.jpg";